(() => {
  const MOBILE_QUERY = '(max-width: 989px)';
  const SWITCH_DURATION_MS = 220;
  const STICKY_TRIGGER_Y = 120;

  const applyModeForWrapper = (wrapper) => {
    if (!wrapper) return;

    const isMobile = window.matchMedia(MOBILE_QUERY).matches;
    if (!isMobile) {
      wrapper.classList.remove('is-fixed-mode', 'is-sticky-mode', 'is-switching');
      return;
    }

    if (!wrapper.dataset.modeInitialized) {
      wrapper.dataset.modeInitialized = 'true';
      wrapper.classList.add('is-fixed-mode');
    }

    const shouldSticky = window.scrollY > STICKY_TRIGGER_Y;
    const hasSticky = wrapper.classList.contains('is-sticky-mode');
    if (shouldSticky === hasSticky) return;

    wrapper.classList.add('is-switching');
    if (shouldSticky) {
      wrapper.classList.remove('is-fixed-mode');
      wrapper.classList.add('is-sticky-mode');
    } else {
      wrapper.classList.remove('is-sticky-mode');
      wrapper.classList.add('is-fixed-mode');
    }

    window.setTimeout(() => {
      wrapper.classList.remove('is-switching');
    }, SWITCH_DURATION_MS);
  };

  const applyModes = () => {
    const wrappers = document.querySelectorAll('.product-form__buttons-wrapper--mobile-sticky');
    wrappers.forEach((wrapper) => applyModeForWrapper(wrapper));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyModes, { once: true });
  } else {
    applyModes();
  }

  document.addEventListener('product-info:loaded', applyModes);
  window.addEventListener('scroll', applyModes, { passive: true });
  window.addEventListener('resize', applyModes);
})();
